import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";
import AddEditResumeModal from "../../ProfileSettings/ProfileSetting/components/AddEditResumeModal";

const Resume = ({ resume, refetchMe, userId }) => {
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Resume</h6>
        {authRole === UserType.ADMIN && (
          <i
            className="fa-light fa-pencil text-gray-900 cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>

      {resume ? (
        <div className="grid grid-cols-4">
          <div className="flex items-center justify-between bg-light rounded-md py-3 px-4 ml-3 border">
            <div className="flex items-center">
              <i className="fa-regular fa-file-pdf text-xl text-red-500"></i>
              <p className="ml-3 text-sm truncate max-w-[120px]">{resume.filename}</p>
            </div>
            <a
              href={resume.url}
              download
              target="_blank"
              rel="noreferrer"
              type="application/octet-stream"
            >
              <i className="fa-solid fa-download text-emerald-700 text-base cursor-pointer"></i>
            </a>
          </div>
        </div>
      ) : (
        <p className="text-sm text-gray-500">No resume uploaded.</p>
      )}

      {isModalOpen && (
        <AddEditResumeModal
          open={isModalOpen}
          close={setIsModalOpen}
          existingResume={resume}
          refetchMe={refetchMe}
          targetUserId={userId}
        />
      )}
    </BaseCard>
  );
};

export default Resume;
